<template>
  <v-container
      id="login"
      class="fill-height justify-center"
      tag="section"
  >
    <Overlay :overlay="globalLoading" :color="'primary'"></Overlay>

    <v-row justify="center" v-show="!globalLoading">
      <v-col cols="12" class="text-center">
        <h1>
          <span class="text-h1">M360API</span> &reg;<br/>
          <span class="text-h2">API Management Platform</span>
        </h1>
      </v-col>
    </v-row>

    <Messages :messages="globalMessages"></Messages>

    <v-row justify="center" v-show="!globalLoading">
      <v-slide-y-transition appear>
        <base-material-card
            color="success"
            light
            max-width="100%"
            width="400"
            class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                Please Enter OTP
              </h1>
            </div>
          </template>
          <form @submit="checkForm" novalidate="true">
            <v-card-text class="text-center">

              <v-otp-input
                  length="6"
                  label="OTP"
                  v-model="OTP"
              ></v-otp-input>

              <pages-btn
                  medium
                  color=""
                  depressed
                  class="mr-1 mb-2 v-btn--text success--text"
                  @click="checkForm"
              >
                <v-icon class="mr-1">mdi-fingerprint</v-icon>
                Submit
              </pages-btn>


            </v-card-text>
          </form>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>

  </v-container>
</template>

<script>
import globalMixins from "../../mixins/globalMixins";
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'Login',

  mixins: [globalMixins],

  components: {
    Overlay: () => import('../../components/OverlayLoading'),
    Messages: () => import('../../components/Messages'),
    PagesBtn: () => import('./components/Btn')
  },

  data: () => ({
    OTP: '',
    qToken: ''
  }),

  async created() {
    this.qToken = this.$router.currentRoute.query.token;
    this.globalLoading = false;
  },

  methods: {
    ...mapActions('auth', ['setToken', 'setUserAndACL']),

    async checkForm(e) {
      if (!this.OTP) {
        this.pushMessage({
          'type': 'error',
          'title': 'Validation Error',
          'text': 'Please provide a valid OTP.'
        });
        return false;
      }
      await this.submit();
      e.preventDefault();
    },

    fetchUserAndAcl() {
      const self = this;
      self.globalLoading = true;
      return self.getSendData({
        url: '/user',
        method: 'get'
      }).then(response => {
        self.setUserAndACL(response);
      }).catch(error => {
        self.handleErrorResponse(error);
      }).finally(() => {
        self.globalLoading = false;
      });
    },

    /* eslint-enable */
    async submit() {
      const self = this;
      return self.executeRequest({
        "method": "post",
        "url": "/otp",
        headers: {
          env: 'portal'
        },
        params: {
          "token": self.qToken,
          "otp": self.OTP
        }
      }).then(async response => {
        self.setToken(response.token);
        self.fetchUserAndAcl()
            .then(() => {
              self.$router.push({'name': 'Dashboard', params: {envCode: 'portal'}});
            });
      }).catch(error => {
        self.handleErrorResponse(error);
      });
    },

  },
  computed: {
    ...mapGetters({user: 'auth/getUser', token: 'auth/getToken'}),
  }
}
</script>
<style>
.or-element {
  position: relative;
}

.or-element::before {
  display: inline-block;
  border-top: 1px solid rgb(184, 196, 194);
  content: "";
  margin: 0 auto;
  position: absolute;
  height: 0;
  inset: 50% 0 0;
  z-index: 0;
  transform: translateY(-50%);
  width: 300px;
}

.or-element span {
  background-color: #FFFFFF;
  padding: 0 10px;
  position: relative;
  top: 2px;
  margin: 0 auto;
  text-align: center;
  z-index: 1;
}
</style>